const { CONSTANTS } = require('../../config')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @param {string} country
 * @param {*} form
 * @param {object} form.applicant.employmentType.value
 * @param {object} form.coApplicant.employmentType.value
 * @param {string} group
 * @param {string} field
 * @param {object} formAlternatives
 * @returns {*}
 */
function filterOptions ({ country, form, group, field, formAlternatives } = {}) {
  if (!country || !form || !group || !field || !formAlternatives) return

  let options = formAlternatives?.[form?.[group]?.[field]?.options]
  const constants = CONSTANTS[country?.toUpperCase()]

  if (field === 'socialEconomicStatus') {
    const selectedEmploymentType = form?.[group]?.employmentType?.value

    if (selectedEmploymentType) {
      let showOptions = []

      switch (selectedEmploymentType) {
        case CONSTANTS.EMPLOYMENT_TYPES.FIXED_PERIOD:
          showOptions = [
            CONSTANTS.SOCIAL_ECONOMIC_STATUSES.WORKER,
            CONSTANTS.SOCIAL_ECONOMIC_STATUSES.OFFICIAL,
            CONSTANTS.SOCIAL_ECONOMIC_STATUSES.SENIOR_OFFICIAL,
            CONSTANTS.SOCIAL_ECONOMIC_STATUSES.MANAGER
          ]

          break
        case CONSTANTS.EMPLOYMENT_TYPES.RETIRED:
          showOptions = [
            CONSTANTS.EMPLOYMENT_TYPES.RETIRED
          ]

          break
      }

      if (showOptions.length) {
        options = options?.filter(item =>
          showOptions.includes(item.value))
      }
    }

    options = options?.filter(item =>
      !constants.HIDE_OPTIONS.socialEconomicStatus.includes(item.value))

    return options
  }

  if (field === 'residenceType') {
    options = options?.filter(item =>
      !constants.HIDE_OPTIONS.residenceType.includes(item.value))

    return options
  }

  if (field === 'residenceOwnershipType') {
    options = options?.filter(item =>
      !constants.HIDE_OPTIONS.residenceOwnershipType.includes(item.value))

    return options
  }

  if (field === 'otherLoanType') {
    const isCredit = form?.[group]?.otherLoanCredit?.value

    options = options?.filter(item =>
      !constants.HIDE_OPTIONS.otherLoanType.includes(item.value))

    options = options?.filter(item =>
      (isCredit === true && item.category === CONSTANTS.BANK_CATEGORY.CREDIT) ||
      (isCredit === false && item.category === CONSTANTS.BANK_CATEGORY.LOAN) ||
      (isCredit !== true && isCredit !== false)
    )

    return options
  }

  return options
}

module.exports = { filterOptions }
